import { createActions } from 'redux-actions'
import { readEvents, updateEvents, moveEvents, transcodeWebinarToHLS } from 'utils/api'

const actions = createActions({
  SETTINGS: {
    SET_MEDIA_PARAMS: (mediaParams) => ({ ...mediaParams })
  },
  MEDIA: {
    READ_EVENTS: readEvents,
    GENERATE_META_FOR_EDIT: ({ uniqueFunc, data, isLoaded }) => ({ uniqueFunc, data, isLoaded }),
    UPDATE_EVENTS: updateEvents,
    MOVE_EVENTS: moveEvents,
    TRANSCODE_WEBINAR: transcodeWebinarToHLS,
    ADD_ITEM: ({ metaItem }) => ({ metaItem }),
    UPDATE_ITEM: ({ metaItem }) => ({ ...metaItem }),
    SET_ACTIVE_ITEM: ({ activeItem }) => ({ activeItem }),
    REMOVE_ITEM: ({ id }) => ({ id }),
    UPDATE_META: ({ meta }) => ({ meta }),
    PLAYER: {
      SET_PLAYER_LOADED: ({ isPlayerLoaded, playerElement }) => ({ isPlayerLoaded, playerElement }),
      SET_CURRENT_DTS: a => a
    },
    SET_NOTIFICATION_STATUS: ({ notificationStatus }) => ({ notificationStatus }),
    SET_INITIAL_STATE: ({ initialState }) => ({ ...initialState })
  }
})

export default actions



// WEBPACK FOOTER //
// ./src/actions/index.js